export default __webpack_public_path__ + "static/media/banner-image.53794838.png";